import { Form, Button, Card, Stack } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../states/AuthContext";
import { login } from "../services/Networkcall";
import { errorAlert, successAlert } from "../components/common/Alert";
import InputField from "../components/common/InputField";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Loader } from "../components/common/Loader";

export default function LoginPage() {

    const { setUserLoggedIn, setUserProfileData } = useContext(AuthContext);
    const [indata, setIndata] = useState({ "email": "", "password": "" });
    const [error, setError] = useState({ "email": "", "password": "" });
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); 

    const togglePassword = () => {
        setShowPassword(!showPassword);
    }

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setIndata((pre) => ({ ...pre, [name]: value }));
        setError((pre) => ({ ...pre, [name]: "" }));
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        let isValid = true;
        if (!indata.email) { isValid = false; setError((pre) => ({ ...pre, "email": "Email is required." })) }
        if (!indata.password) { isValid = false; setError((pre) => ({ ...pre, "password": "Password is required." })) }

        if (isValid) {
            try {
                setLoading(true);
                const data = { "email": indata.email, "password": indata.password }
                const res = await login(data);
                if (res?.success) {
                    setUserLoggedIn(true);
                    setUserProfileData(res?.data)
                    localStorage.setItem("userLoggedIn", "true");
                    localStorage.setItem("userAuthToken", res?.data?.token);
                    localStorage.setItem("userProfileData", JSON.stringify(res?.data));
                    successAlert({ message: res?.message })
                    navigate("/")
                }
                else{ 
                errorAlert({message: res?.message })
                }
            } catch (err) {
                errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
            } finally {
                setLoading(false);
            }

        }

    }

   

    return (
        <div className="login-wrapper">
            <Loader show={loading} />
            <Card className="login-card">
                <div className="login-header">
                    <h3 className="mb-0">TruckTuck <span>PRO</span></h3>
                    <p className="mb-0">Login to your dashboard</p>
                </div>

                <Form onSubmit={submitHandler}>
                    <Stack gap={3} direction="vertical">

                        <InputField
                            label={'Email'}
                            type="email"
                            name={'email'}
                            placeholder="Enter email"
                            value={indata.email}
                            required={true}
                            onChange={inputHandler}
                            error={error.email}
                        />

                        <InputField
                            label={'Password'}
                            type={showPassword ? "text" : "password"}
                            name={'password'}
                            placeholder="Enter password"
                            className={'rounded '}
                            value={indata.password}
                            onChange={inputHandler}
                            error={error.password}
                            endIcon={showPassword ? <FiEyeOff onClick={togglePassword} /> : <FiEye onClick={togglePassword} />}
                        />
                        <Link to='/forgot-password' className="text-end text-decoration-none small">Forgot Password ?</Link>

                        <Button type="submit" className="login-btn w-100 mt-2 ">
                            Login
                        </Button>
                    </Stack>
                </Form>
            </Card>

        </div>
    );
}